'use client';

import { Card, CardBody, CardFooter, Chip } from '@heroui/react';
import { IoWarningOutline } from 'react-icons/io5';
import { PropertyDetails } from '../../SchedulerContext';
import { AddressForScheduler } from '@/util/types/globalTypes';
import { PROPERTY_FIELDS, getFieldLabel } from '../propertyFormConfig';
import { getUnverifiedAddressFieldLabels } from '../propertyRequirements';

interface VerificationWarningsProps {
  address: AddressForScheduler;
  propertyDetails: PropertyDetails | null;
}

/**
 * Displays verification warnings for auto-populated data
 * Shows chips for each unverified field
 */
export default function VerificationWarnings({
  address,
  propertyDetails,
}: VerificationWarningsProps) {
  // These were inline truthy checks (`address.sqft && !sqftVerified`),
  // which silently dropped `sqft: 0` and `unitCount: 0` — the field-level warning
  // icon rendered while the chip here did not, so the user saw a warning with no
  // explanation. Both now read the same definition, and required fields that are
  // missing are reported as blocking errors upstream instead of as warnings here.
  const addressWarnings = getUnverifiedAddressFieldLabels(address);

  // const propertyWarnings = propertyDetails
  //   ? PROPERTY_FIELDS.filter((field) => {
  //       const value = propertyDetails[field.name];
  //       const isVerified = propertyDetails[field.verifiedField];

  //       // For count fields, always check verification
  //       if (field.showWarningAlways) {
  //         return !isVerified;
  //       }

  //       // For other fields, only check if value exists
  //       return value !== undefined && !isVerified;
  //     }).map((field) => field.label)
  //   : [];

  const allWarnings: string[] = [
    ...addressWarnings,
    // ...propertyWarnings
  ];

  if (allWarnings.length === 0) {
    return null;
  }

  return (
    <Card className='border-2 border-warning'>
      <CardBody className='space-y-3'>
        <div className='flex items-center gap-2'>
          <IoWarningOutline className='text-2xl text-warning' />
          <h5 className='text-lg font-semibold'>
            Please Verify Property Details
          </h5>
        </div>
        <p className='text-sm'>
          Some property details were automatically populated from Zillow and
          need your verification. Please review and update the fields marked
          with a warning icon above.
        </p>
        <CardFooter className='p-0'>
          <div className='flex flex-wrap gap-2'>
            {allWarnings.map((warning) => (
              <Chip key={warning} color='warning' variant='flat' size='sm'>
                {warning}
              </Chip>
            ))}
          </div>
        </CardFooter>
      </CardBody>
    </Card>
  );
}
